import React from "react";
import { StyledTab } from "./Tab.styled";

const Tab = ({ children, ...props }) => {
  return <StyledTab {...props}>{children}</StyledTab>;
};

export default Tab;
